import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { AgGridFilterOption } from 'core/enums';
import { formatDate } from 'core/utils';
import { QuoteIdCell } from 'quotes/elements';

import { AttachExistingVendorQuoteColId } from './enums';

export const columnDef = (): ColDef[] => [
  {
    colId: AttachExistingVendorQuoteColId.EXTERNAL_NUMBER,
    headerName: t('headerVendorQuote'),
    width: 200,
    field: 'externalNumber',
    filter: 'agTextColumnFilter',
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: AttachExistingVendorQuoteColId.ID,
    headerName: t('headerQuoteId'),
    field: 'id',
    filter: 'agTextColumnFilter',
    pinned: 'left',
    lockPinned: true,
    cellRenderer: QuoteIdCell,
  },
  {
    colId: AttachExistingVendorQuoteColId.VENDOR_CONTACT_GROUP_NAME,
    headerName: t('headerVendor'),
    field: 'vendorContactGroupName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: AttachExistingVendorQuoteColId.VENDOR_CONTACT_NAME,
    headerName: t('headerContact'),
    field: 'vendorContactName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: AttachExistingVendorQuoteColId.JOB_NAME,
    headerName: t('headerJob'),
    width: 200,
    field: 'jobName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: AttachExistingVendorQuoteColId.CUSTOMER_PROJECT_NAME,
    headerName: t('headerProject'),
    width: 200,
    field: 'customerProjectName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: AttachExistingVendorQuoteColId.EXTERNAL_PROJECT_NAME,
    headerName: t('headerVendorProject'),
    width: 200,
    field: 'externalProjectName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: AttachExistingVendorQuoteColId.CUSTOMER_CORPORATE_USER_NAME,
    headerName: t('headerUser'),
    width: 200,
    field: 'customerCorporateUserName',
    filter: 'agTextColumnFilter',
  },
  {
    colId: AttachExistingVendorQuoteColId.START_DATE,
    headerName: t('headerEffectiveDate'),
    width: 200,
    field: 'startDate',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: AttachExistingVendorQuoteColId.VALID_UNTIL,
    headerName: t('headerExpiryDate'),
    width: 200,
    field: 'validUntil',
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
    },
    valueFormatter: ({ value }) => formatDate(value),
  },
];
